// Auto-generated from label.spec.js
export default {
  "tagName": "ui-label",
  "types": [
    "emphasis"
  ],
  "variations": [
    "badge",
    "size"
  ],
  "attributes": [
    "emphasis",
    "badge",
    "size"
  ],
  "optionAttributes": {
    "secondary": "emphasis",
    "outline": "emphasis",
    "mini": "size",
    "tiny": "size",
    "small": "size",
    "medium": "size",
    "large": "size",
    "big": "size",
    "huge": "size",
    "massive": "size"
  },
  "propertyTypes": {
    "emphasis": "string",
    "badge": "boolean",
    "size": "string"
  },
  "allowedValues": {
    "emphasis": [
      "secondary",
      "outline"
    ],
    "size": [
      "mini",
      "tiny",
      "small",
      "medium",
      "large",
      "big",
      "huge",
      "massive"
    ]
  }
};
